import { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import Update_data_modal from "../../components/manageInvoice/update_data_modal/index";
import DataTable_Component from "../../components/candidate/Data Table/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";

import Layouts from "../../layouts/layouts";
import Add_data_modal from "../../components/candidate/update_data_modal";
import CandidateDetailModal from "../../components/candidate/Candidate Details";
import * as XLSX from "xlsx";

export default function Candidate() {
  const title = "Candidate Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showCandidateDetailModal, setShowCandidateDetailModal] =
    useState(false);
  const [selectedCandidate, setSelectedCandidate] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];
  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };
  const columns = [
    {
      name: <b>Candidate Id</b>,
      selector: (row) => row.candidateId,
      sortable: true,
    },
    // {
    //   name: <b>Job Id</b>,
    //   selector: (row) => (row.jobId ? row.jobId.jobId : "-"),
    //   sortable: true,
    // },
    {
      name: <b>Job Id</b>,
      selector: (row) => (row.jobId ? row.jobId.jobId : "-"),
      sortable: true,
      wrap: true, // ✅ Allows wrapping into multiple lines
      grow: 2, // ✅ Gives more width compared to other columns
      style: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        lineHeight: "1.4",
      },
    },

    {
      name: <b>Name</b>,
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: <b>Contact</b>,
      selector: (row) => row.phoneNumber,
      sortable: true,
    },
    {
      name: <b>Date</b>,
      selector: (row) => formatDate(row.date || "-"),
      sortable: true,
    },
    {
      name: <b>City</b>,
      selector: (row) => (row.jobId ? row.jobId.city : "-"),
      sortable: true,
    },
    {
      name: <b>Supervisor/RM</b>,
      selector: (row) => (row.userId ? row.userId.name : "-"),
      sortable: true,
    },

    {
      name: <b>Approved</b>,
      selector: (row) => row.approved,
      sortable: true,
    },
    {
      name: <b>Created By</b>,
      selector: (row) => {
        const map = {
          public: { label: "USER", color: "primary" },
          user: { label: "USER", color: "primary" },
          admin: { label: "TEAM", color: "success" },
          superadmin: { label: "TEAM", color: "success" },
          clientmanager: { label: "TEAM", color: "success" },
        };

        const entry = map[row.createdBy] || {
          label: row.createdBy,
          color: "secondary",
        };

        return (
          <span
            className={`badge bg-${entry.color}`}
            style={{ padding: "6px 10px", fontSize: "13px" }}
          >
            {entry.label}
          </span>
        );
      },
      sortable: true,
    },

    {
      name: <b>Status</b>,
      cell: (row) => {
        const status = row.status?.trim();

        return (
          <button
            className={`btn px-2 py-1 ${
              status === "Pending"
                ? "btn-success"
                : status === "In-Progress"
                  ? "btn-danger"
                  : status === "Hired"
                    ? "btn-primary"
                    : status === "Rejected"
                      ? "btn-secondary"
                      : status === "Closed"
                        ? "btn-dark"
                        : ""
            }`}
            style={{
              minWidth: "100px",
              fontSize: "14px",
              whiteSpace: "nowrap",
            }}
          >
            {status || "Unknown"}
          </button>
        );
      },
      width: "150px",
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          <button
            onClick={() => setUpdateStoreBtn(row)}
            className="btn btn-info btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
          <button
            onClick={() => delete_row(row)}
            className=" btn btn-danger btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>

          <button
            onClick={() => viewCandidate(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        </>
      ),
    },
  ];

  const exportToExcel = () => {
    const transformedData = apistate.map((candidate) => ({
      Candidate_ID: candidate.candidateId,
      Job_ID: candidate.jobId ? candidate.jobId?.jobId : "-",

      Name: candidate.name,
      Contact: candidate.phoneNumber,
      Email: candidate.email || "-",

      Address: candidate.address,
      License_Number: candidate.licenseNumber,
      Aadhar_Number: candidate.aadharNumber,

      Supervispor: candidate.jobId ? candidate.userId?.name : "-",

      City: candidate.jobId ? candidate.jobId.city : "-",

      Status: candidate.status,
      Approved: candidate.approved,
      Description: candidate.description,
      Comments: candidate.comments,

      Resume: candidate.resume?.url || "-",
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, "Applicants");

    XLSX.writeFile(workbook, "applicants.xlsx");
  };

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const fetchData = async (page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/applicants`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (Array.isArray(response.data.applicants)) {
        setApiState(response.data.applicants);
      } else {
        console.error("Unexpected data format from API", response.data);
      }
      setApiCol(columns);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const delete_row = (row) => {
    Swal.fire({
      icon: "warning",
      title: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }

        axios
          .delete(
            `${process.env.REACT_APP_BASE_URL}/api/v1/applicants/${row.candidateId}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          )
          .then(() => {
            Swal.fire("Deleted!", "Candidate has been deleted.", "success");
            fetchData(currentPage);
          })
          .catch((error) => {
            Swal.fire("Error!", "Candidate could not be deleted.", "error");
            console.error("Error deleting candidate:", error);
          });
      }
    });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const viewCandidate = (candidate) => {
    setSelectedCandidate(candidate);
    setShowCandidateDetailModal(true);
  };
  const updateCandidate = (updatedCandidate) => {
    setApiState((prev) =>
      prev.map((candidate) =>
        candidate.candidateId === updatedCandidate.candidateId
          ? updateCandidate
          : candidate,
      ),
    );
  };

  const handleUpdateCandidate = (updatedCandidateData) => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    axios
      .put(
        `${process.env.REACT_APP_BASE_URL}/api/v1/applicants/${updatedCandidateData.applicantId}`,
        updatedCandidateData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        Swal.fire(
          "Updated!",
          "Candidate details have been updated.",
          "success",
        );
        updateCandidate(response.data.applicants); // update local state
      })
      .catch((error) => {
        Swal.fire("Error!", "Job details could not be updated.", "error");
        console.error(
          "Error updating candidate:",
          error.response ? error.response.data : error.message,
        );
      });
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateCandidate={updateCandidate}
      />
      <CandidateDetailModal
        show={showCandidateDetailModal}
        onHide={() => setShowCandidateDetailModal(false)}
        candidate={selectedCandidate}
      />
      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>

                <div>
                  <Link to="/create_candidate">
                    <div className="btn btn-info btn-sm text-white me-2">
                      Add Candidate
                    </div>
                  </Link>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>
              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="name"
                    title_btn={true}
                    title="Applicants List"
                    apidata={apistate}
                    columns={apicol}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
